import React, { memo, ReactElement } from 'react';
import { Props as TopBarProps, TopBar as TopBarComponent } from 'b2b-components/theme/components/Header/TopBar';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';
import { Props } from './';

const TopBar = ({ ...props }: Props): ReactElement => {
  const topBarProps = {
    ...props,
  } as TopBarProps<LANGUAGE_CODE>;

  return (
  <TopBarComponent {...topBarProps} />
  );
};

const MemoizedTopBar = memo(TopBar);

export { MemoizedTopBar as TopBar };
